import { Component, Host, h, State, Listen, Element, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
    tag: 'sew-ws-tooltip',
    styleUrl: 'sew-ws-tooltip.scss',
    shadow: false,
})
export class SewWsTooltip {
    @Element() host: HTMLSewWsTooltipElement;
    @Prop() delay = false;
    @State() isOpen = false;
    @State() hasNoTarget = false;
    @Event() tooltipToggle: EventEmitter<boolean>;
    private timeoutId;

    @Listen('mouseover')
    public onMouseOver(): void {
        if (!this.isOpen) {
            this.openTooltip();
        }
    }

    @Listen('mouseleave')
    public onMouseLeave(): void {
        this.closeTooltip();
    }

    @Listen('resize', { target: 'window' })
    public onResize(): void {
        if (this.isOpen) {
            requestAnimationFrame(() => this.calculateOffset());
        }
    }

    private tooltipRef: HTMLElement;

    private openTooltip() {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(
            () => {
                this.isOpen = true;
                requestAnimationFrame(() => this.calculateOffset());
                this.tooltipToggle.emit(true);
            },
            this.delay ? 3000 : 0
        );
    }

    private closeTooltip() {
        clearTimeout(this.timeoutId);
        this.isOpen = false;
        this.tooltipToggle.emit(false);
    }

    private calculateOffset() {
        this.tooltipRef.style.marginLeft = `0`;

        const parentSelector = document.querySelector('body');
        const parentRect = parentSelector.getBoundingClientRect();

        let marginOffset: number | undefined;

        if (window.matchMedia('(max-width: 767px)').matches) {
            this.tooltipRef.style.width = parentSelector.offsetWidth + 'px';
        }

        const tooltipRect = this.tooltipRef.getBoundingClientRect();

        if (tooltipRect.left < parentRect.left) {
            marginOffset = parentRect.left - tooltipRect.left;
        } else if (tooltipRect.right > parentRect.right) {
            marginOffset = -(tooltipRect.right - parentRect.right);
        }

        if (marginOffset !== undefined) {
            this.tooltipRef.style.marginLeft = `${Math.floor(marginOffset)}px`;
        }
    }

    componentWillLoad(): void {
        this.hasNoTarget = !this.host.querySelector('[slot="target"]');

        this.host.querySelectorAll('sew-ws-richtext').forEach(el => el.classList.add('sew-ws-dark'));
    }

    render() {
        return (
            <Host class={{ '--hide': !this.isOpen, 'has-target': !this.hasNoTarget, 'delay': this.delay }}>
                <slot name="target"></slot>
                {this.hasNoTarget && <sew-icon class="info-icon" icon="info-filled" height="24" width="24" />}
                <div ref={tooltipRef => (this.tooltipRef = tooltipRef)} class="tooltip">
                    <slot></slot>
                </div>
            </Host>
        );
    }
}
